import {httpGet,httpPut,httpDelete,httpPost,httpPostForm,httpDownload} from '@/util/request.js';
import appConfig from '@/config';

export default class SpecialCostApi{

  static QUERY_SPECIAL_COST_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/list";
  static SPECIAL_COST_DETAIL_DETAIL = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/detail";
  static SOURCE_COST_DATA = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/sourceData";
  static SPECIAL_COST_DETAIL_SYNC = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/sync";
  static SPECIAL_COST_IMPORT_DATA = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/importData";
  static SPECIAL_COST_EXPORT_DATA = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/exportData";
  static SPECIAL_COST_IMPORT_TEMPLATE = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/importTemplate";

  static SPECIAL_COST_SUBMIT = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/submit";
  static SPECIAL_COST_APPROVE = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/approve";
  static SPECIAL_COST_DISMISSAL = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/dismissal";
  
  static QUERY_SPECIAL_ADJUST_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/adjust/list";
  static QUERY_SPECIAL_ADJUST_DETAIL = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/adjust/detail";

  static SPECIAL_ADJUST_IMPORT_DATA = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/adjustImportData";
  static SPECIAL_ADJUST_IMPORT_TEMPLATE = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/adjustTemplate";

  static SPECIAL_ADJUST_PASSED = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/adjust/passed";
  static SPECIAL_ADJUST_UNPASSED = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/adjust/unpassed";

  static SPECIAL_COST_IMPLEMENT_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/implement/list";
  static SPECIAL_COST_IMPLEMENT_ENTER = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/implement/enter";
  static SPECIAL_COST_PROJECT_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/manage/special/project/list";

    static sourceData(params){
		  return httpPost(SpecialCostApi.SOURCE_COST_DATA,params);
    }

    static list(params){
		  return httpGet(SpecialCostApi.QUERY_SPECIAL_COST_LIST,params);
    }

    static detail(params){
		  return httpGet(SpecialCostApi.SPECIAL_COST_DETAIL_DETAIL,params);
    }

    static sync(params){
      return httpPostForm(SpecialCostApi.SPECIAL_COST_DETAIL_SYNC,params);
    }

    static importData(file,costId){
      let formData = new FormData()
      formData.append('file', file);
      formData.append('costId', costId);
      return httpPost(SpecialCostApi.SPECIAL_COST_IMPORT_DATA,formData);
    }

    static exportData(params){
		return httpDownload(SpecialCostApi.SPECIAL_COST_EXPORT_DATA,params);
    }

    static importTemplate(params){
		  return httpDownload(SpecialCostApi.SPECIAL_COST_IMPORT_TEMPLATE,params);
    }

	static submit(params){
		return httpPut(SpecialCostApi.SPECIAL_COST_SUBMIT,params);
  }
	static approve(params){
		return httpPut(SpecialCostApi.SPECIAL_COST_APPROVE,params);
  }
	static dismissal(params){
		return httpPut(SpecialCostApi.SPECIAL_COST_DISMISSAL,params);
  }

  static listAdjust(params){
    return httpGet(SpecialCostApi.QUERY_SPECIAL_ADJUST_LIST,params);
  }

  static detailAdjust(params){
    return httpGet(SpecialCostApi.QUERY_SPECIAL_ADJUST_DETAIL,params);
  }

  static importAdjustTemplate(params){
    return httpDownload(SpecialCostApi.SPECIAL_ADJUST_IMPORT_TEMPLATE,params);
  }

  static importAdjustData(file,costId){
    let formData = new FormData()
    formData.append('file', file);
    formData.append('costId', costId);
    return httpPost(SpecialCostApi.SPECIAL_ADJUST_IMPORT_DATA,formData);
  }

  static adjustPassed(params){
		return httpPut(SpecialCostApi.SPECIAL_ADJUST_PASSED,params);
  }

  static adjustUnpassed(params){
		return httpPut(SpecialCostApi.SPECIAL_ADJUST_UNPASSED,params);
  }

  static listImplement(params){
    return httpGet(SpecialCostApi.SPECIAL_COST_IMPLEMENT_LIST,params);
  }

  static implementEnter(params){
		return httpPut(SpecialCostApi.SPECIAL_COST_IMPLEMENT_ENTER,params);
  }

  static getProjectList(){
      return httpGet(SpecialCostApi.SPECIAL_COST_PROJECT_LIST,{});
  }

}